document.addEventListener('DOMContentLoaded', function() {
    // Contact Form 7のフォーム要素を取得
    const forms = document.querySelectorAll('.wpcf7-form');
    
    forms.forEach(function(form) {
        form.addEventListener('submit', function() {
            // テキスト、メール、URL、電話番号、テキストエリアを取得
            const inputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="url"], input[type="tel"], textarea');
            
            inputs.forEach(function(input) {
                // 前後の全角・半角スペースをトリム（すべてスペースの場合は空文字になる）
                input.value = input.value.replace(/^[\s　]+|[\s　]+$/g, '');
            });
        });
    });
});

document.querySelectorAll('.wpcf7 input[type="date"]').forEach(input => {
    input.addEventListener('keydown', e => {
        // Tab・Shift+Tabなどフォーカス移動キーは許可する
        const allowedKeys = ['Tab', 'Escape'];
        if (!allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
    });
    input.addEventListener('paste', e => e.preventDefault());
});

document.addEventListener( 'wpcf7invalid', function( event ) {
    // 最初のエラーメッセージが表示されている要素（または入力フィールド）を取得
    const firstError = document.querySelector('.wpcf7-not-valid-tip');
    
    if ( firstError ) {
        // 要素の位置までスムーズにスクロール
        firstError.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' // 画面の中央付近にくるように調整（'start' や 'end' も可）
        });
    }
}, false );

document.addEventListener('DOMContentLoaded', () => {
    const submitButtons = document.querySelectorAll('.wpcf7-form input[type="submit"]');
    const form = document.querySelector('.wpcf7-form');

    if (!form || submitButtons.length === 0) return;

    // 1. 送信ボタンがクリックされたら無効化（連打防止）
    //    disabled にすることでマウスクリックに加え、テキストフィールドでの
    //    エンターキーによる暗黙の送信（implicit submission）も防げる
    form.addEventListener('submit', () => {
        submitButtons.forEach(button => {
            button.disabled = true;
            button.style.opacity = '0.5'; // 見た目を半透明にして操作不可を伝える
        });
    });

    // 2. バリデーションエラー等で送信失敗した場合、ボタンを元に戻す
    const reactivateButtons = () => {
        submitButtons.forEach(button => {
            button.disabled = false;
            button.style.opacity = '1';
        });
    };

    // Contact Form 7のカスタムイベントをリッスン
    document.addEventListener('wpcf7invalid', reactivateButtons, false); // 入力エラー時
    document.addEventListener('wpcf7spam', reactivateButtons, false);    // スパム判定時
    document.addEventListener('wpcf7mailfailed', reactivateButtons, false); // 送信失敗時

    // 3. Confirm Plus Contact Form 7 の確認画面から「修正する」で戻ったとき、ボタンを元に戻す
    //    （戻るボタンは動的生成されるためイベント委譲で拾う）
    document.addEventListener('click', (e) => {
        if (e.target.closest('.wpcf7cp-cfm-edit-btn')) {
            reactivateButtons();
        }
    });

    // 4. 確認画面の「この内容で送信」は、プラグインが元の送信ボタンの click() を
    //    呼び出して本送信する仕組みのため、disabled のままだと送信できない。
    //    キャプチャ段階でプラグインの処理より先に disabled を解除しておく
    document.addEventListener('click', (e) => {
        if (e.target.closest('.wpcf7cp-cfm-submit-btn')) {
            reactivateButtons();
        }
    }, true);
});
